import StoreConnections from "./StoreConnections/StoreConnections";
import RecommendationPanel from "./RecommendationPanel/RecommendationPanel";
import ConnectStoreModal from "./ConnectStoreModal/ConnectStoreModal";
import { useSelector, useDispatch } from 'react-redux';
import { setHeaderTitle } from "../../../store";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import StickySettings from "./StoreConnections/StickySettings/StickySettings";



const DashboardContent = () => {
    const dispatch = useDispatch();
    const [modalOpen, setModalOpen] = useState(false);
    const navigate = useNavigate()
    const design = (
        <main class="p-6">
            {/* <StickySettings /> */}
            <StoreConnections />
            <ConnectStoreModal isOpen={modalOpen} onClose={setModalOpen} />
        </main>
    );
    return design;
}

export default DashboardContent;